import { FC } from 'react'

import styled from 'styled-components'

import { PrimaryInfoModal } from 'src/Components/PrimaryInfoModal'
import { PrimaryButton } from 'src/Components/Buttons/PrimaryButton'
import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'

const StyledModal = styled(PrimaryInfoModal)`
  max-width: 400px;
`

const Content = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
`

const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: 'Segoe UI';
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};

  p {
    margin: 0;
  }
`

const Buttons = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
`

const KeepButton = styled(PrimaryButton)`
  width: fit-content;
  padding-left: 40px;
  padding-right: 40px;
`

export interface DisableAutoRenewModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

export const DisableAutoRenewModal: FC<DisableAutoRenewModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => (
  <StyledModal
    isOpen={isOpen}
    onClose={onClose}
    title='Keep your campaign running'
  >
    <Content>
      <Text>
        <p>
          Your campaign will automatically renew with the same daily budget and
          duration.
        </p>
        <p>
          This gives Meta&apos;s algorithm more time to optimize and can help
          improve your results over time.
        </p>
        <p>You can turn off auto-renew anytime.</p>
      </Text>
      <Buttons>
        <KeepButton onClick={onClose}>Keep auto-renew</KeepButton>
        <PrimaryDottedButton onClick={onConfirm}>
          Turn off anyway
        </PrimaryDottedButton>
      </Buttons>
    </Content>
  </StyledModal>
)
